import { render, staticRenderFns } from "./CheckDeclinedFooter.vue?vue&type=template&id=9245e2ae"
import script from "./CheckDeclinedFooter.vue?vue&type=script&lang=js"
export * from "./CheckDeclinedFooter.vue?vue&type=script&lang=js"
import style0 from "./CheckDeclinedFooter.vue?vue&type=style&index=0&id=9245e2ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports